import React, { Component } from "react";
import { Layout, Row, Col } from "antd";
import { Link } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { connect } from 'react-redux';
import propTypes from "prop-types";
import { Div } from "./style";
import AuthInfo from "../components/utilities/auth-info/info";
import moment from "moment";
import SidebarMenu from "./SidebarMenu";
import TopMenu from "./TopMenu";
import PermissionDenied from "./PermissionDenied";
import SurveyQuizBlock from "./SurveyQuizBlock";
import CatalogueFooter from "./CatalogueFooter";
import TVPanelBlock from "../components/dashboard/TVPanelBlock";
import { isFullStoreLock } from "../components/utilities/RouteGate";
import { changeLayoutMode } from '../redux/themeLayout/actionCreator';
import { skipSurveyQuiz, submitSurveyQuiz, updateSurveyQuizToken } from "../redux/authentication/actionCreator";

const { darkTheme } = require("../config/theme/themeVariables");
const {
  Header,
  Footer,
  Content
} = Layout;

const ThemeLayout = (WrappedComponent) => {

    class LayoutComponent extends Component {
        constructor(props) {
            super(props);
            this.state = {
                hide: false,
                collapsed: false, // window.innerWidth <= 1200,
            };
        }

        componentDidMount() {
            window.addEventListener("resize", this.updateDimensions);
        }

        componentWillUnmount() {
            window.removeEventListener("resize", this.updateDimensions);
        }

        updateDimensions = () => {
            // this.setState({ collapsed: window.innerWidth <= 1200 }); 
            this.setState({ collapsed: true }); // Force collapsed state for now
        };

        toggleCollapsed = () => {
            this.setState((prevState) => ({ collapsed: !prevState.collapsed }));
        };

        toggleCollapsedMobile = () => {
            if (window.innerWidth <= 768) {
                this.setState((prevState) => ({ collapsed: !prevState.collapsed }));
            }
        };

        handleSurveySkip = () => {
            const { surveyQuiz, skipSurveyQuiz } = this.props;
            skipSurveyQuiz(surveyQuiz?.uniqueToken, surveyQuiz?.surveyId, surveyQuiz?.router);
        };

        handleSurveyUpdateToken = () => {
            const { surveyQuiz, updateSurveyQuizToken } = this.props;
            updateSurveyQuizToken(surveyQuiz?.uniqueToken, surveyQuiz?.surveyId, surveyQuiz?.router);
        };

        handleSurveySubmit = (answers) => {
            const { surveyQuiz, submitSurveyQuiz } = this.props;
            submitSurveyQuiz(surveyQuiz?.uniqueToken, surveyQuiz?.surveyId, answers);
        };

        render() {
                        const {
  storePermission,
  surveyQuiz
} = this.props;
            const darkMode = false; //ChangeLayoutMode; 
            const xs = window.innerWidth <= 576; // Adjust breakpoint as needed
            const isStoreLocked = storePermission?.allowed === false && isFullStoreLock(storePermission?.lockType);
            const isTvPanelBlocked = storePermission?.status === 'succeeded' && (storePermission?.isTvDownloaded === true || storePermission?.isTvDownloaded === 'true' || storePermission?.isTvDownloaded === 1 || storePermission?.isTvDownloaded === '1');
            const isSurveyBlocked = surveyQuiz?.status === 'succeeded' && (surveyQuiz?.required === true || surveyQuiz?.processing === true);
            const isPanelBlocked = isStoreLocked || isSurveyBlocked || isTvPanelBlocked;

            if (isTvPanelBlocked) {
                return <TVPanelBlock />;
            }

            return (
                <Div darkMode={darkMode}>
                    <Layout className="layout">
                        <Header>
                            <Row gutter={[16, 16]}>
                                <Col xxl={5} lg={5} md={6} sm={6} xs={7} className='d-flex'>
                                    <div className={"logo"} >
                                        {!xs ? (
                                            <Link to="/">
                                                <img src={darkMode ? require(`../static/img/login-logo.png`) : require(`../static/img/logo.png`)} alt="logo" width={'110'} />
                                            </Link>
                                        ) : (
                                            <Link to="/">
                                                <img src={require(`../static/img/logo-icon.png`)} alt="logo" width={'50%'} />
                                            </Link>
                                        )}
                                        {!isPanelBlocked && <SidebarMenu />}
                                        {/*
                                        {!xs && (
                                            <Button type="link" onClick={this.toggleCollapsed}>
                                                <img src={require(`../static/img/icon/${collapsed ? "right.svg" : "left.svg"}`)} alt="menu" />
                                            </Button>
                                        )}
                                        */}
                                    </div>
                                </Col>
                                <Col xxl={13} lg={13} md={12} sm={10} xs={10} className='d-flex'>
                                    {!isPanelBlocked && <TopMenu darkMode={darkMode} />}
                                </Col>
                                <Col xxl={6} lg={6} md={6} sm={8} xs={7}>
                                    <AuthInfo darkMode={darkMode} />
                                </Col>
                            </Row>
                        </Header>
                        <Layout>
                            <ThemeProvider theme={darkTheme}>
                                <Layout>
                                    <Content style={{ minHeight: 'calc(100vh - 128px)', width: '100%' }}>
                                        {isStoreLocked ? (
                                            <PermissionDenied title="Complete Module is Locked" message={storePermission?.error || 'This portal is locked by HO.'} details={storePermission?.details} locked />
                                        ) : isSurveyBlocked ? (
                                            <SurveyQuizBlock surveyQuiz={surveyQuiz} onSkip={this.handleSurveySkip} onUpdateToken={this.handleSurveyUpdateToken} onSubmit={this.handleSurveySubmit} />
                                        ) : (
                                            <WrappedComponent {...this.props} />
                                        )}
                                    </Content>
                                </Layout>
                            </ThemeProvider>
                        </Layout>
                        {!isPanelBlocked && (
                            <Footer className="admin-footer" style={{ padding: "20px 30px" }}>
                                <CatalogueFooter />
                                <div className="admin-footer-copyright">
                                    <span>© 2018–{moment().format("YYYY")}</span>
                                    <a
                                        href="https://www.skilledanswers.com/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        SkilledAnswers Info Solutions Pvt Ltd
                                    </a>
                                </div>
                            </Footer>
                        )}
                    </Layout>
                </Div>
            );
        }
    }

    const mapStateToProps = (state) => {
            return {
                ChangeLayoutMode: state.ChangeLayoutMode.data,
                storePermission: state.storePermission,
                surveyQuiz: state.surveyQuiz,
            };
        };

    const mapStateToDispatch = (dispatch) => {
        return {
            changeLayout: (show) => dispatch(changeLayoutMode(show)),
            skipSurveyQuiz: (uniqueToken, surveyId, router) => dispatch(skipSurveyQuiz(uniqueToken, surveyId, router)),
            updateSurveyQuizToken: (uniqueToken, surveyId, router) => dispatch(updateSurveyQuizToken(uniqueToken, surveyId, router)),
            submitSurveyQuiz: (unique_token, quizSurveyId, quizData) =>dispatch(submitSurveyQuiz(unique_token, quizSurveyId, quizData)),
        };
    };

    LayoutComponent.propTypes = {
        ChangeLayoutMode: propTypes.bool,
        rtl: propTypes.bool,
        topMenu: propTypes.bool,
        changeRtl: propTypes.func,
        changeMenuMode: propTypes.func,
    };



    return connect(mapStateToProps, mapStateToDispatch)(LayoutComponent);
};

export default ThemeLayout;
